import { Colors } from '@/common/colors/colors';
import Input from '@/common/components/Input';
import PopUp from '@/common/components/PopUp';
import React, { useRef, useState, useEffect } from 'react';
import { OrderNavigateWrapper } from '../../ValidInvoicesTable.styled';
import ActionButton from '@/common/components/buttons/ActionButton';
import { ButtonWrapper } from '../../../../ValidInvoices.styled';
import { EditableWrapper } from './CorrectionInvoice.styled';
import { useRequestsContext } from '@/common/hooks/requestHook';
import {
	acceptCorrectionInvoice,
	generateCorrectionInvoicePreview,
	updateCorrectionInvoice,
} from '@/API/repositories/tickets';
import InvoicePreview from '@/pages/admin/validInvoices/common/components/invoicePreview/InvoicePreview';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import moment from 'moment';
import { useInvoiceConfigForCountry } from '@/pages/admin/validInvoices/hooks/useInvoiceConfigForCountry';
import SelectInput from '@/common/components/SelectInput';
import Icon from '@/common/components/Icon';
const pako = require('pako');

const CorrectionInvoiceEdit = ({
	setSelectedTicket,
	selectedTicket,
	handleSearch,
	isRestricted,
}) => {
	const [updateColor, setUpdateColor] = useState(Colors.orange);
	const [generateColor, setGenerateColor] = useState(Colors.orange);
	const [pdfSource, setPdfSource] = useState();
	const [showWarning, setShowWarning] = useState();
	const [selectedReason, setSelectedReason] = useState();
	const issueDateRef = useRef();

	const { makeRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();
	const { invoiceConfig } = useInvoiceConfigForCountry(
		selectedTicket?._contact?.country,
	);

	const todayIssueDate = moment().format('YYYY-MM-DD');

	const reasonOptions =
		invoiceConfig?.correction_reasons?.map((reason) => ({
			value: reason,
			label: reason,
		})) || [];

	useEffect(() => {
		initReason();
	}, [reasonOptions]);

	const initReason = () => {
		if (!!selectedTicket?.valid_invoice?.correction_reason && !selectedReason) {
			setSelectedReason({
				value: selectedTicket?.valid_invoice?.correction_reason,
				label: selectedTicket?.valid_invoice?.correction_reason,
			});
		} else if (reasonOptions.length > 0 && !selectedReason) {
			const defaultReason = reasonOptions[0];
			setSelectedReason(defaultReason);
		}
	};

	const handleUpdateCorrectionInvoice = async () => {
		const payload = {};
		payload.correctionReason = selectedReason?.value;

		const response = await makeRequest(
			updateCorrectionInvoice.bind(null, selectedTicket?._id, payload),
		);

		if (!response?.data) {
			setUpdateColor(() => Colors.red);
			setTimeout(() => {
				setUpdateColor(() => Colors.orange);
			}, 3000);

			return addMessage("Couldn't update", 'error');
		}

		await handleSearch();
		setUpdateColor(() => Colors.green);
		setTimeout(() => {
			setUpdateColor(() => Colors.orange);
		}, 3000);
		addMessage('Success', 'success');
	};

	const handleAcceptCorrectionInoice = async () => {
		setShowWarning(() => false);

		const response = await makeRequest(
			acceptCorrectionInvoice.bind(null, selectedTicket._id),
		);

		if (!response.data) {
			return addMessage('Something went wrong', 'error');
		}

		await handleSearch();
		addMessage('Success', 'success');
		setPdfSource(() => null);
		setSelectedTicket(() => null);
	};

	const handleGenerateCorrectionInvoicePreview = async () => {
		const payload = {};

		if (!selectedReason?.value) {
			addMessage('Select a reason', 'error');
			return;
		}

		payload.issue_date = issueDateRef.current?.value;
		payload.ticketId = selectedTicket?._id;
		payload.correctionReason = selectedReason?.value;

		const response = await makeRequest(
			generateCorrectionInvoicePreview.bind(null, payload),
		);

		if (!response?.data?.data) {
			setGenerateColor(() => Colors.red);
			setTimeout(() => {
				setGenerateColor(() => Colors.orange);
			}, 3000);

			return addMessage("Couldn't generate", 'error');
		}

		const uint8Array = new Uint8Array(response.data.data);

		const decompressed = pako.inflate(uint8Array);

		const blob = new Blob([decompressed], {
			type: 'application/pdf',
		});

		const url = URL.createObjectURL(blob);

		setPdfSource(() => url);

		await handleSearch();
		setGenerateColor(() => Colors.green);
		setTimeout(() => {
			setGenerateColor(() => Colors.orange);
		}, 3000);
		addMessage('Success', 'success');
	};

	return (
		<PopUp padding='10px 20px 14px' setShow={setSelectedTicket}>
			<OrderNavigateWrapper>
				<Icon
					onClick={() =>
						window.open(`/dashboard/order/${selectedTicket.order}`, '_blank')
					}
					name='truck'
				/>
			</OrderNavigateWrapper>
			<EditableWrapper>
				<Input
					type='date'
					name='Issue date'
					color={Colors.darkBlue}
					inputRef={issueDateRef}
					width={120}
					inputWidth={300}
					value={todayIssueDate}
					disabled
				/>
				<SelectInput
					color={Colors.darkBlue}
					name='Reason'
					options={reasonOptions}
					value={selectedReason}
					selected={selectedReason}
					setSelected={(value) => setSelectedReason(value)}
					width={120}
					selectWidth={520}
				/>
			</EditableWrapper>
			<ButtonWrapper>
				<ActionButton
					color={updateColor}
					defaultText='Save'
					onClick={() => handleUpdateCorrectionInvoice()}
				/>
				<ActionButton
					color={generateColor}
					defaultText='Generate preview'
					onClick={() => handleGenerateCorrectionInvoicePreview()}
					disabled={isRestricted}
				/>
			</ButtonWrapper>
			{pdfSource && (
				<InvoicePreview
					showWarning={showWarning}
					setShowWarning={setShowWarning}
					pdfSource={pdfSource}
					setPdfSource={setPdfSource}
					handleAccept={() => handleAcceptCorrectionInoice()}
				/>
			)}
		</PopUp>
	);
};

export default CorrectionInvoiceEdit;
